export default "__VITE_ASSET__BSM2zUP2__"